// extracted by mini-css-extract-plugin
module.exports = {"container":"landing_container__cBZJZ","title":"landing_title__3_1hx","boton":"landing_boton__kssg9","copyright":"landing_copyright__WdwGK"};